export default function findCardLinks() {
    const cards = document.querySelectorAll('.spv-card, .spv-listCard');
    cards?.forEach(card => {
        let down;
        let up;
        let ctrlIsPressed;
        const link = card.querySelector('a');
        const originalTargetAttribute = link?.getAttribute('target');
        function setOrRemoveAttr() {
            originalTargetAttribute
                ? link?.setAttribute('target', originalTargetAttribute)
                : link?.removeAttribute('target');
        }
        card.onmousedown = e => {
            ctrlIsPressed = e.ctrlKey || e.metaKey;
            down = +new Date();
        };
        card.onmouseup = e => {
            up = +new Date();
            const fastClick = up - down < 200;
            ctrlIsPressed ? link?.setAttribute('target', '_blank') : setOrRemoveAttr();
            if (e.button === 0 && fastClick) {
                link?.click();
            }
        };
    });
}
findCardLinks();
//# sourceMappingURL=card.js.map